<template>
  <section class="min-h-screen overflow-hidden">
    <div
      class="absolute z-10 flex w-full flex-col items-center justify-center"
      style="top: calc(var(--status-bar-height, 0px) + 0.5rem + 9px)"
    >
      <FreedomTravelLogo class="text-text-neutral-primary" />
      <Transition name="fade" mode="out-in">
        <div :key="currentTip">
          <p
            class="text-text-neutral-primary mt-16 px-4 text-center text-lg font-semibold"
          >
            {{ rt(tipRotationList[currentTip]) }}
          </p>
        </div>
      </Transition>
    </div>
    <div class="relative" style="width: 200vw">
      <slot name="back-button"></slot>
      <img
        v-if="isDarkMode"
        src="@/assets/images/loader/kolsay-loader-dark.webp"
        class="animate-background h-screen w-full object-cover"
        alt="Фон загрузки результатов"
        @animationstart="handleAnimationStart"
        @animationiteration="handleAnimationIteration"
      />
      <img
        v-else
        src="@/assets/images/loader/kolsay-loader.webp"
        class="animate-background h-screen w-full object-cover"
        alt="Фон загрузки результатов"
        @animationstart="handleAnimationStart"
        @animationiteration="handleAnimationIteration"
      />
      <img
        class="animate-plane absolute top-48"
        src="@/assets/images/loader/plane.svg"
        alt="Загрузка результатов"
        width="121"
        height="32"
      />
    </div>
  </section>
</template>

<script setup lang="ts">
  import { computed, ref } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { createStorage } from '@aviata/storage';

  import FreedomTravelLogo from '@/assets/images/freedom-travel-logo-80x24.svg?component';

  const { tm, rt } = useI18n();

  const storage = createStorage(localStorage);

  const isDarkMode = computed(() => {
    const theme = storage.get('theme');
    return theme === 'dark';
  });

  const tipRotationList = tm('search.loader.tip') as string[];

  const currentTip = ref(0);

  function* createNumberRotator(): Generator<number, never, undefined> {
    let currentValue = currentTip.value;

    while (true) {
      yield currentValue;
      currentValue = (currentValue + 1) % tipRotationList.length;
    }
  }

  const rotator = createNumberRotator();

  function handleAnimationStart() {
    currentTip.value = rotator.next().value;
  }

  function handleAnimationIteration() {
    currentTip.value = rotator.next().value;
  }
</script>

<style scoped>
  .animate-background {
    animation: results-loader-background-shift 6.5s ease-in-out infinite
      forwards;
  }

  .animate-plane {
    animation: results-loader-plane-move 6.5s linear infinite forwards;
  }

  @keyframes results-loader-background-shift {
    0%,
    10% {
      opacity: 0;
      transform: translateX(0);
    }
    10%,
    40% {
      opacity: 1;
      transform: translateX(0);
    }
    45%,
    60% {
      transform: translateX(0);
    }
    60%,
    100% {
      transform: translateX(-100vw);
    }
  }

  @keyframes results-loader-plane-move {
    0%,
    12% {
      left: -122px;
    }
    100% {
      left: 100%;
    }
  }
</style>
